import React from 'react'
import AspectRatioBox from '../AspectRatioBox'
import Icon from '../Icon'
import cn from 'classnames'

export type BasicCardProps = {
  onRenderImage: () => JSX.Element
  onRenderFootnote?: () => JSX.Element
  variant?: 'extra-tall' | 'tall'
  externalLinkIcon?: boolean
}

const BasicCard: React.FC<BasicCardProps> = ({
  onRenderImage,
  children,
  onRenderFootnote,
  variant = 'short',
  externalLinkIcon = false
}) => {
  return (
    <div
      className={cn('basic-card p-2', {
        'basic-card--tall': variant === 'tall',
        'basic-card--extra-tall': variant === 'extra-tall'
      })}
    >
      <AspectRatioBox ratio='widescreen'>{onRenderImage()}</AspectRatioBox>
      <div className='basic-card__content mt-2'>{children}</div>
      {/* footnote area is optional */}
      {onRenderFootnote && <div className='basic-card__footnote'>{onRenderFootnote()}</div>}
      {externalLinkIcon && <Icon className='basic-card__external-link-icon' type='externalLink' />}
    </div>
  )
}

export default BasicCard
